import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Mail, Loader2 } from "lucide-react";
import { API } from "../../context/AuthContext";
import { Switch } from "../ui/switch";

const display = "font-display";

export default function RecapPanel() {
  const [enabled, setEnabled] = useState(true);
  const [lastSent, setLastSent] = useState(null);
  const [sending, setSending] = useState(false);

  useEffect(() => {
    axios.get(`${API}/recap/settings`).then((res) => {
      setEnabled(res.data.enabled);
      setLastSent(res.data.last_sent);
    }).catch(() => {});
  }, []);

  const toggle = async (value) => {
    setEnabled(value);
    try {
      await axios.patch(`${API}/recap/settings`, { enabled: value });
      toast.success(value ? "Weekly Flux Recap enabled!" : "Weekly recaps paused.");
    } catch {
      setEnabled(!value);
      toast.error("Couldn't update recap settings.");
    }
  };

  const sendNow = async () => {
    setSending(true);
    try {
      const res = await axios.post(`${API}/recap/send`);
      setLastSent(new Date().toISOString());
      toast.success(`Recap with ${res.data.event_count} events sent to your inbox!`);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Couldn't send the recap.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="bg-[#131f3a] border border-white/5 p-5 rounded-2xl shadow-xl space-y-3" data-testid="recap-panel">
      <div className="flex items-center justify-between">
        <h4 className="text-xs font-bold uppercase tracking-wider text-gray-300 flex items-center gap-2">
          <Mail className="w-3.5 h-3.5 text-[#f59e0b]" /> Weekly Flux Recap
        </h4>
        <Switch checked={enabled} onCheckedChange={toggle} data-testid="recap-toggle" />
      </div>
      <p className="text-[11px] text-gray-400 leading-relaxed">
        Professor Flux emails you a weekly digest of new events across all your timelines.
        {lastSent && <span className="block mt-1 font-mono text-[10px]">Last sent: {new Date(lastSent).toLocaleDateString()}</span>}
      </p>
      <button
        onClick={sendNow}
        disabled={sending}
        data-testid="recap-send-now-btn"
        className={`w-full border border-[#f59e0b]/30 hover:border-[#f59e0b]/60 text-[#f59e0b] ${display} font-bold py-2.5 px-4 rounded-xl text-[11px] uppercase tracking-wider transition-colors duration-200 active:scale-[0.98] flex items-center justify-center gap-2`}
      >
        {sending ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Mail className="w-3.5 h-3.5" />}
        Send My Recap Now
      </button>
    </div>
  );
}
